module.exports = __webpack_public_path__ + "img/huodong-default.4be73fa3.png";